import React, { memo, forwardRef } from "react";
const SvgInfinity = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M12.003 13.577a3.54 3.54 0 100 5.007l2.503-2.503-2.503-2.504zm3.918 1.09l-2.504-2.504a5.54 5.54 0 00-8.426 7.138c1.99 2.785 6.005 3.118 8.426.697l2.504-2.503 2.503 2.503a5.54 5.54 0 008.426-7.138c-1.99-2.785-6.006-3.118-8.426-.697l-2.503 2.503zm1.414 1.414l2.503 2.503a3.54 3.54 0 100-5.007l-2.503 2.504z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgInfinity.displayName = "SvgInfinity";
const MemoForwardRef = memo(SvgInfinity);
export default MemoForwardRef;
